// =============== ADAPTIVE QUESTION SELECTOR HOOK ===============
// Performance-based adaptive question selection

import { useState, useCallback, useEffect } from 'react';
import { selectNextQuestion } from '../../../engine/adaptiveSelector';
import { getQuestionsByModule } from '../../../engine/questionLake';

export const useQuestionSelector = (module) => {
  const [askedQuestionIds, setAskedQuestionIds] = useState([]);
  const [answersById, setAnswersById] = useState({});
  const [currentQuestion, setCurrentQuestion] = useState(null);
  
  const allQuestions = getQuestionsByModule(module);
  
  useEffect(() => {
    if (allQuestions.length > 0 && !currentQuestion) {
      const firstQuestion = selectNextQuestion({
        module,
        allQuestions,
        askedQuestionIds: [],
        answersById: {}
      });
      setCurrentQuestion(firstQuestion);
      if (firstQuestion) setAskedQuestionIds([firstQuestion.id]);
    }
  }, [module, allQuestions, currentQuestion]);
  
  const goToNext = useCallback((answer) => {
    if (!currentQuestion) return;
    
    setAnswersById(prev => ({ ...prev, [currentQuestion.id]: answer }));
    
    const nextQuestion = selectNextQuestion({
      module,
      allQuestions,
      askedQuestionIds,
      answersById: { ...answersById, [currentQuestion.id]: answer }
    });
    
    if (nextQuestion) {
      setCurrentQuestion(nextQuestion);
      setAskedQuestionIds(prev => [...prev, nextQuestion.id]);
    } else {
      setCurrentQuestion(null);
    }
  }, [module, allQuestions, askedQuestionIds, answersById, currentQuestion]);
  
  const resetModule = useCallback(() => {
    setAskedQuestionIds([]);
    setAnswersById({});
    setCurrentQuestion(null);
  }, []);
  
  return {
    currentQuestion,
    goToNext,
    resetModule,
    askedQuestionIds,
    answersById,
    progress: askedQuestionIds.length / allQuestions.length
  };
};

export default useQuestionSelector;